module.exports = "https://store.zigzag.kr/resources/arm64/20260227-1533-3ffb2bd4d2_store/_next/static/images/MedalVip-70c82bf8a20d9dddc5ddf2bb049a43eb.png";